module.exports = __webpack_public_path__ + "img/keypad.2ffbd71c.png";